import React from 'react'
import { IntegrationsOpenCartSec } from './integrationsOpenCartSec'

export const IntegrationsOpenCart = () => {
  return (
    <IntegrationsOpenCartSec />
  )
}
